import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col, Card } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { HORSE_TABLE_COLUMNS_STATIC, HORSE_TABLE_ALL_COLUMNS_STATIC } from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import { getAllRaceDetails, getMatchPrediction, getRaceDetails, getWinnerInfo, getRunnerOddsByMarketId } from '../../service/backend-api-service';
import Spinner from "../UI/Spinner"
import { Button, ButtonGroup } from 'react-bootstrap'
import "react-sliding-pane/dist/react-sliding-pane.css"
import RaceSlidingPane from "../RaceSlidingPane"
import VolumeMatched from './League/VolumeMatched';
import sortIconImage from "../../assets/images/sort_both.png"
import AiAgentTips from './League/AiAgentTips';

const LeagueTable = (props) => {
    const [sortOrder, setSortOrder] = useState(true) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(1)
    const [race, setRace] = useState({})
    const [runner, setRunner] = useState({})
    const [raceType, setRaceType] = useState(null)
    const [prediction, setPrediction] = useState(null);
    const [oddsMap, setOddsMap] = useState({});       // { selectionId: oddsData }
    const [winnerInfo, setWinnerInfo] = useState(null); // { winner, places } for single race
    const [winnerMap, setWinnerMap] = useState({});    // { marketId: winnerInfo } for ALL view

    const staticColumns = []
    for (let value in HORSE_TABLE_COLUMNS_STATIC) staticColumns.push(HORSE_TABLE_COLUMNS_STATIC[value])

    const staticColumnsAll = []
    for (let value in HORSE_TABLE_ALL_COLUMNS_STATIC) staticColumnsAll.push(HORSE_TABLE_ALL_COLUMNS_STATIC[value])

    const finalColumns = raceType === 'ALL' ? [...staticColumnsAll] : [...staticColumns];

    const sortIconClickedHandler = columnId => {
        //logInfo(`LeagueTable | sortIconClickedHandler | called. column id: ${columnId}`)
        setSortColumn(columnId)
        if(sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        if(column.id === HORSE_TABLE_COLUMNS_STATIC.RDB_RATING.id ||
            column.id === HORSE_TABLE_COLUMNS_STATIC.WFF_RATING.id ||
            column.id === HORSE_TABLE_COLUMNS_STATIC.OR.id ||
            column.id === HORSE_TABLE_COLUMNS_STATIC.RPR_RATING.id){
            sortIcon =  <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        }

        if (column.id === HORSE_TABLE_COLUMNS_STATIC.ODD_DETAILS.id) {
            return (
                <th key={column.id}><ButtonGroup size="sm">
                    <Button style={{ fontSize: "10px", padding: "3px", backgroundColor: "#74BBEF", color: "#1a2035", borderColor: "#5aa8e8" }} variant="outline-dark"><b>Bk</b></Button>
                    <Button style={{ fontSize: "10px", padding: "3px", backgroundColor: "#F8AAB8", color: "#1a2035", borderColor: "#e888a0" }} variant="outline-dark"><b>Ly</b></Button>
                </ButtonGroup>
                </th>
            );
        } else {
            return (
                <th key={column.id}>{column.description} {sortIcon}</th>
            );
        }
    })

    const compare = (a, b) => {
        if(a === b) return 0
        if(a === null || a === "-") return 1
        if(b === null || b === "-") return -1
        if(sortOrder) return parseFloat(a) < parseFloat(b) ? -1 : 1;
        else return parseFloat(a) < parseFloat(b) ? 1 : -1;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (race && race.date) {
                setLoadingState(0)
                let apiData = race.type === 'ALL' ? await getAllRaceDetails(race.date) : await getRaceDetails(race)
                if(apiData.length > 0 && sortColumn != null) {
                    apiData.sort((a, b) =>{
                        if(sortColumn == "RDB_RATING "){
                            return compare(a["runnerRdbRating"], b["runnerRdbRating"]);
                        }else if(sortColumn == "WFF_RATING "){
                            return compare(a["wff"], b["wff"]);
                        }else if(sortColumn == "RPR_RATING "){
                            return compare(a["rpr"], b["rpr"]);
                        }else if(sortColumn == "OR "){
                            return compare(a["runnerOR"], b["runnerOR"]);
                        }

                    });
                }
                props.setSoccerLeaguesState(apiData)
                const aiPrediction = race && race.raceId ?
                <Card style={{ padding: "0px" }}>
                    <Card.Header style={{padding: "0px"}}><b>Ai Agent Tips</b></Card.Header>
                    <Card.Body style={{ padding: "0px" }}>
                        <Card.Text>
                        <AiAgentTips matchId={race.raceId} date={race.date} />
                        </Card.Text>
                        
                    </Card.Body>
                </Card>
                : null;
                setPrediction(aiPrediction)
                if (apiData) {
                    setLoadingState(2)
                } else {
                    setLoadingState(1)
                }
            }
        }
        setRunner({});
        setRaceType(race.type)
        fetchData();
    }, [sortColumn, sortOrder,race])


    useEffect(() => {
        setRace({});
        setRunner({});
        setLoadingState(1)
        props.setSoccerLeaguesState(null)
    }, [props.selectionState])

    // Odds + winner data — WebSocket for single race, REST polling for ALL view
    useEffect(() => {
        setOddsMap({});
        setWinnerInfo(null);
        setWinnerMap({});

        const runners = props.soccerLeaguesState;
        if (!runners || !runners.length) return;

        if (race.type === 'ALL') {
            // ALL view: poll REST API per runner (multiple markets, WebSocket can't handle this)
            const date = race.date;

            const pollAllOdds = async () => {
                const eligible = runners.filter(r => r.bfMarketId && r.bfSelectionId);
                const results = await Promise.all(
                    eligible.map(r => getRunnerOddsByMarketId(r.bfMarketId, r.bfSelectionId, date))
                );
                const newMap = {};
                results.forEach((odds, i) => {
                    if (odds) newMap[eligible[i].bfSelectionId] = odds;
                });
                setOddsMap(newMap);
            };

            const pollAllWinners = async () => {
                const uniqueMarkets = [...new Map(
                    runners.filter(r => r.bfMarketId).map(r => [r.bfMarketId, r])
                ).values()];
                const newWinnerMap = {};
                await Promise.all(
                    uniqueMarkets.map(async r => {
                        const info = await getWinnerInfo(r.bfMarketId, date, r.raceTime);
                        if (info && info.winner) newWinnerMap[r.bfMarketId] = info;
                    })
                );
                setWinnerMap(newWinnerMap);
            };

            pollAllOdds();
            pollAllWinners();
            const interval = setInterval(() => { pollAllOdds(); pollAllWinners(); }, 15000);
            return () => clearInterval(interval);
        }

        // Single race: WebSocket for live odds
        const marketId = runners.find(r => r.bfMarketId)?.bfMarketId;
        if (!marketId) return;

        const date = race.date;
        const time = race.raceTime;

        const ws = new WebSocket('wss://rpmapi.makebettinggreat.com/v1/horse/odds/live');

        ws.onopen = () => {
            ws.send(JSON.stringify({ marketId }));
        };

        ws.onmessage = (event) => {
            const updates = JSON.parse(event.data); // List<HorseRunnerOdd>
            const newMap = {};
            updates.forEach(u => { newMap[u.selectionId] = u; });
            setOddsMap(newMap);
        };

        ws.onerror = (err) => console.error('Odds WebSocket error', err);

        const pollWinner = async () => {
            const info = await getWinnerInfo(marketId, date, time);
            if (info && info.winner) setWinnerInfo(info);
        };

        pollWinner();
        const winnerInterval = setInterval(pollWinner, 5000);

        return () => {
            ws.close();
            clearInterval(winnerInterval);
        };
    }, [props.soccerLeaguesState, race]);

    const clickHandler = (runner) => {
        //setSortColumn(columnId)
        //if (sortColumn === columnId) setSortOrder(!sortOrder)
        //console.log(runner);
        setRunner(runner);
    }

    const getCountryName = (code) => {
        //setSortColumn(columnId)
        if (code === "SA") {
            return "South Africa";
        }else if(code === "UK"){
            return "United Kingdom";

        }else if(code === "IRE"){
            return "Ireland"
        }
        return code;
        //console.log(runner);
        setRunner(runner);
    }

    let itemList

    if (race.type === 'ALL') {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={item.raceDayStr} time={item.raceTime}
                    finalColumns={finalColumns} type="ALL" item={item} race={race} index={index}
                    oddsMap={oddsMap} winnerInfo={winnerMap[item.bfMarketId]} />
            }) : null
    } else {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={race.date} time={race.raceTime}
                    finalColumns={finalColumns} clickHandler={clickHandler} item={item} race={race} index={index}
                    oddsMap={oddsMap} winnerInfo={winnerInfo} />
            }) : null;
    }

    const volumeMatched = (race.type !== 'ALL' && props.soccerLeaguesState && props.soccerLeaguesState.length > 0 &&
        props.soccerLeaguesState[0].bfMarketId) ?
        <VolumeMatched marketId={props.soccerLeaguesState[0].bfMarketId} /> : null

    const header = race && race.raceVenue ?
        <>
        <Card style={{ padding: "0px" }}>
            <Card.Header style={{padding: "2px" }}>
                Country : {getCountryName(race.countryCode)} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Venue : {race.raceVenue} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {volumeMatched}   ID: {race.raceId}<br></br>
                {race.title}
                
            </Card.Header>
        </Card>
            <div style={{ display: "none" }} id="raceId">
                {race.raceId}
            </div>
        </>
        : null;

    const getFirstVerdict = (verdict, verdicts) => {
        if (verdicts && verdicts.length > 0) {
            return verdicts[0].verdict;
        }
        if (verdict) {
            let index = verdict.indexOf("Verdict2:")
            if (index != -1) {
                return verdict.substring(0, index);
            }
        }
        return verdict;
    }    

    const getSecondVerdict = (verdict, verdicts) => {
        if (verdicts && verdicts.length > 1) {
            return verdicts[1].verdict;
        }
        if (verdict) {
            let index = verdict.indexOf("Verdict2:")
            if (index != -1) {
                return verdict.substring(index);
            }
        }
        return "";
    }    

    const receVerdict = race && (race.verdict || race.verdicts) ?
        <Card style={{ margin: "0px" }}>
            <Card.Header style={{padding: "2px" }}><b>Race Verdict</b></Card.Header>
            <Card.Body style={{ padding: "2px" }}>
                <Card.Text style={{margin:"1px"}}>
                    <b>Verdict1:</b>{' '}{getFirstVerdict(race.verdict, race.verdicts)}
                </Card.Text>
                <Card.Text style={{color:"#22c55e", margin:"1px"}}>
                  <b>Tip1:</b>{' '}{race.verdicts && race.verdicts.length > 0 ? race.verdicts[0].verdictTip : ""}
                </Card.Text>
                <Card.Text style={{margin:"1px"}}>
                  <b>Verdict2:</b>{' '}{getSecondVerdict(race.verdict, race.verdicts)}
                </Card.Text >
                <Card.Text style={{color:"#22c55e", margin:"1px"}}>
                   <b>Tip2:</b>{' '}{race.verdicts && race.verdicts.length > 1 ? race.verdicts[1].verdictTip : ""}
                </Card.Text>
            </Card.Body>
        </Card>
        : null;

    const runnerForm = runner && runner.runnerFormWatch ?
        <Card style={{ padding: "0px" }}>
            <Card.Header style={{padding: "2px" }}><b>Form Watch: {runner.runnerName}</b></Card.Header>
            <Card.Body style={{ padding: "2px" }}>
                <Card.Text>
                    {runner.runnerFormWatch}
                </Card.Text>
                
            </Card.Body>
        </Card>
        : null;

        const raceForecast = runner && runner.forecast ?
        <Card style={{ padding: "0px" }}>
            <Card.Header style={{padding: "2px" }}><b>Forecast:</b></Card.Header>
            <Card.Body style={{ padding: "2px" }}>
                <Card.Text>
                    {runner.forecast}
                </Card.Text>
            </Card.Body>
        </Card>
        : null;    

    let contentBody = null

    if (loadingState === 0) {
        contentBody = <Spinner />
    } else if (loadingState === 1) {
        contentBody = <div style={{ textAlign: "center", color: "#4a5578", fontFamily: "'IBM Plex Mono', monospace", fontSize: "15px", paddingTop: "40px", letterSpacing: "0.5px", fontWeight: "500" }}>Select a race from the sidebar</div>
    } else {
        contentBody =
            <>
                <b>{header} </b>
                <Table className="LeagueTable" style={{ fontSize: "13px" }} id="runnerDetails" triped bordered hover size="sm">
                    <thead>
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {itemList}

                    </tbody>
                </Table>
                <Container style={{ marginLeft: "inherit" }}>
                    <Row>
                        <Col>{receVerdict}</Col>
                        <Col>{prediction}<br></br>{runnerForm}<br></br>{raceForecast}</Col>
                    </Row>
                </Container>
            </>
    }
    return (
        <Container fluid className={classes.LeagueTable} style={{ display: "flex", flexDirection: "row", padding: 0 }}>
            <div style={{ width: "155px", minWidth: "155px", height: "100vh", overflowY: "auto", overflowX: "hidden", background: "#d6ceaa", borderRight: "1px solid rgba(26,32,53,0.15)", flexShrink: 0 }}>
                <RaceSlidingPane selectionDate={props.selectionState.selectionDate} raceSelectHandler={setRace} />
            </div>
            <div style={{ flex: 1, overflowX: "auto", overflowY: "auto", minWidth: 0, paddingLeft: "2px" }}>
                {contentBody}
            </div>
        </Container>
    )
}


const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);